import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Seo from '../components/Seo'
import ServiceCard from '../components/ServiceCard'
import { services } from '../data/services'
import { company } from '../data/company'
import './services.css'

const Services = () => {
  return (
    <div className="page">
      <Seo
        title="Services"
        path="/services"
        description="Product development, digital software, cloud, and data & analytics from Konsri Technologies — the team behind FinQ."
      />
      <Navbar />

      <header className="hero-band services-hero">
        <div className="container services-hero__inner">
          <h1 className="services-hero__title">Our Services</h1>
          <p className="services-hero__subtitle">
            Engineering partnerships for teams that need to design, build, and operate software —
            grounded in how we run FinQ ourselves.
          </p>
        </div>
      </header>

      <section className="section services-detail-section">
        <div className="container">
          <div className="services-detail-grid">
            {services.map((service) => (
              <ServiceCard key={service.id} service={service} detailed />
            ))}
          </div>
        </div>
      </section>

      <section className="section services-cta-band">
        <div className="container services-cta-inner">
          <h2 className="services-cta__title">Ready to talk?</h2>
          <p className="services-cta__text">
            Tell us what you are building or operating. We will reply with a clear next step.
          </p>
          <a href={`mailto:${company.email}`} className="btn btn-primary">
            Email {company.email}
          </a>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default Services
